import * as React from 'react';
import { resolve } from 'inversify-react';
import { observer } from 'mobx-react';

import { AgentBrandView } from './agent-brand.view';
import { AgentBrandDataService } from './agent-brand-form.data';

interface Props extends ComponentViewProps<AgentItem> {
	dataService: AgentBrandDataService;
	mode: ControlMode;
}

@observer
export class AgentBrandController extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}

	handleCreateAgentBrand = async(): Promise<AgentBrandItem> => {
		const { dataService, model } = this.props;
		let brand = await dataService.add(model);
		return brand;
	};

	render() {
		const { dataService, mode, setBusy } = this.props;
		if (dataService == null || dataService.items == null) {
			return null;
		}

		return (
			<AgentBrandView
				model={dataService}
				onCreateAgentBrand={this.handleCreateAgentBrand}
				mode={mode}
				setBusy={setBusy}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/agent-brands/agent-brand.controller.tsx